export const arrFeeType = ["share", "referrer", "coupon", "creator", "royalty"] as const;
export type FeeType = typeof arrFeeType[number];

//Comisiones (de los settings o de algún cliente)
export interface Fees {
  share: number;
  referrer: number;
  coupon: number;
  creator: number;
  royalty: number;
}

/**
 * Defines the structure of a fee range, which includes optional minimum and maximum usage counts and a mapping of fee
 * levels to their corresponding fee amounts.
 */
export interface FeeRange {
  min?: number;
  max?: number;
  feeByLevel: Map<ReferrerFeeLevel, number>;
}

/**
 * Defines the different fee levels that can be applied to referrers. The `STANDARD` level represents the default fee,
 * while the `BONUS` level can be used to provide an increased fee for referrers who meet certain criteria.
 */
export enum ReferrerFeeLevel {
  STANDARD = 'standard',
  BONUS = 'bonus'
}

/**
 * Defines the structure of the next fee level information, including the fee amount for the next level,
 * the number of uses needed to reach that level, and the level index.
 */
export interface NextFeeLevelInfo {
  fee: number;
  usesNeeded: number;
  level: number;
}
